import { validatePostcode } from '../address_helpers';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const CurrencyFormatter = require('currency-formatter');
const cardValidator = require('card-validator');
const padStart = require('string.prototype.padstart');

const checkExpirationDate = (month, year) => {
  const today = new Date();
  const exp = new Date();
  exp.setFullYear(year, month, 1);
  return today < exp;
};

const formatCurrency = (number, currencyCode) => {
  return CurrencyFormatter.format(number, { code: currencyCode });
};

const getTotalCost = (planTypes, activePlanType, verifiedCoupon, currencyCode) => {
  const activePlan = planTypes.find(planType => planType.planCode === activePlanType);
  let totalCost = activePlan.priceTotal;
  if (verifiedCoupon && verifiedCoupon.discountedPricePerYear && activePlanType !== 1) {
    totalCost = verifiedCoupon.discountedPricePerYear;
  }
  return formatCurrency(Number(totalCost), currencyCode);
};

const getTotalBaseAnnualCost = (planTypes, activePlanType, currencyCode) => {
  const activePlan = planTypes.find(planType => planType.planCode === activePlanType);
  const totalCost = activePlan.priceTotal;
  return formatCurrency(Number(totalCost), currencyCode);
};

const getMonths = () => {
  const monthStrings = StringConstantsMixin.strings.MONTHS;
  const result = [{ title: '', value: '', string: '' }];
  // the 'value' and 'string' properties of this object allow for more robust autocomplete
  monthStrings.map((item, index) => {
    const monthNumber = index + 1;
    const monthNumberString = padStart(monthNumber.toString(), 2, 0);
    result.push({ title: `${item} (${monthNumberString})`, value: monthNumber, string: monthNumberString });
  });
  return result;
};

const getYears = () => {
  const result = [{ title: '', value: '' }];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i < currentYear + 10; i++) {
    result.push({ title: i.toString(), value: i });
  }
  return result;
};

const getMonthByNumber = monthNum => {
  const months = getMonths();
  return months.find(month => month.value === monthNum);
};

const getYearByNumber = yearNum => {
  const years = getYears();
  return years.find(year => year.value === yearNum);
};

const validatePaymentForm = (name, value, monthAndYear, errors, text, codeSize) => {
  let maxCodeSize = codeSize;
  let invalidDate;
  let response;
  switch (name) {
    case 'name':
      if (value.length < 1) {
        errors[name] = text[name].validation.generic;
      } else if (value.split(' ').length < 2) {
        errors[name] = text[name].validation.lastName;
      } else {
        errors[name] = '';
      }
      break;
    case 'number':
      response = cardValidator.number(value);
      if (value.length < 1) {
        errors[name] = text[name].validation.generic;
      } else if (response.isPotentiallyValid) {
        if (response.code) {
          maxCodeSize = response.code.size;
        }
        errors[name] = '';
      } else {
        errors[name] = !response.isPotentiallyValid ? text[name].validation.generic : '';
      }
      break;
    case 'cvv':
      errors[name] = value.length > 4 || value.length < 3 ? text[name].validation.generic : '';
      break;
    case 'cc-exp-month':
      if (monthAndYear['cc-exp-year']) {
        //   // if year is selected, validate both
        invalidDate = !value || !checkExpirationDate(value.value, monthAndYear['cc-exp-year'].value);
        errors['cc-exp-month'] = invalidDate ? text.month.validation.generic : '';
        errors['cc-exp-year'] = invalidDate ? text.year.validation.generic : '';
      } else {
        errors['cc-exp-year'] = text.year.validation.generic;
      }
      break;
    case 'cc-exp-year':
      if (monthAndYear['cc-exp-month']) {
        invalidDate = !value || !checkExpirationDate(monthAndYear['cc-exp-month'].value, value.value);
        errors['cc-exp-month'] = invalidDate ? text.month.validation.generic : '';
        errors['cc-exp-year'] = invalidDate ? text.year.validation.generic : '';
      } else {
        errors['cc-exp-month'] = text.month.validation.generic;
      }
      break;
    case 'postalCode':
      errors[name] = !validatePostcode(value, 'INTL') || value.length === 0 ? text.postalCode.validation.generic : '';
      break;
    default:
      break;
  }

  return { [name]: value, errors, maxCodeSize };
};

export { validatePaymentForm, formatCurrency, getMonths, getYears, getMonthByNumber, getYearByNumber, getTotalCost, getTotalBaseAnnualCost };
